import { connect } from 'react-redux';
import { IState } from '../../reducers';

import { fetchEventItemByIdAction } from './actions/fetchEventItemById';

import {EventPage} from './eventPage';


const mapStateToProps = (state: IState, ownProps: any) => ({
    eventItem: state.eventsAndNewsItems.latestSelectedEventItem,
    eventItemId: ownProps.params.id
});

const mapDispatchToProps = (dispatch: any) => ({
    fetchEventItemById: (id: string) => dispatch(fetchEventItemByIdAction(id)),
});

export const EventPageContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(EventPage);


// WEBPACK FOOTER //
// ./src/components/eventPage/eventPageContainer.tsx